import {ErrorsRanked} from '../errors/ErrorsRanked.ts'
import {ModeSettingEnum} from '@colonist/game-base-types'
import {GameModeDataController} from '@colonist/shared-types'
import {type UserItems} from '../store/UserItems.ts'
import {type ABTestCategory} from '../ABTestTypes.ts'

export enum CKRankedState {
    Locked,
    Unlocked,
    HasFreeGames,
    HasFreeGameFromDiceRoll,
    CanRollDice,
    WaitingToRollDice,
}

export const CK_FREE_GAME_COUNT = 5
export const MINIMUM_DICE_ROLL_FOR_FREE_GAME = 4

export function userHasAccessToRankedCitiesAndKnights(userItems: UserItems | undefined, ckTotalGameCount: number | undefined, abTestGroups: Partial<Record<ABTestCategory, string>>, nextRerollAt: Date | undefined, freePlayUntil: Date | undefined): boolean {
    const ckRankedState = getCKRankedState(userItems, ckTotalGameCount, abTestGroups, nextRerollAt, freePlayUntil)
    if(ckRankedState == CKRankedState.Unlocked) return true
    if(ckRankedState == CKRankedState.HasFreeGames) return true
    if(ckRankedState == CKRankedState.HasFreeGameFromDiceRoll) return true
    return false
}

export function shouldLockRankedCitiesAndKnights(userItems: UserItems | undefined, ckTotalGameCount: number | undefined, abTestGroups: Partial<Record<ABTestCategory, string>>, nextRerollAt: Date | undefined, freePlayUntil: Date | undefined): boolean {
    const ckRankedState = getCKRankedState(userItems, ckTotalGameCount, abTestGroups, nextRerollAt, freePlayUntil)
    if(ckRankedState == CKRankedState.Locked) return true
    if(ckRankedState == CKRankedState.WaitingToRollDice) return true
    return false
}

export function getCKRankedState(userItems: UserItems | undefined, ckTotalGameCount: number | undefined, abTestGroups: Partial<Record<ABTestCategory, string>>, nextRerollAt: Date | undefined, freePlayUntil: Date | undefined): CKRankedState {
    if(userHasNormalAccessToCitiesAndKnights(userItems)) return CKRankedState.Unlocked
    if(userHasFreeCitiesAndKnightsGame(abTestGroups, ckTotalGameCount)) return CKRankedState.HasFreeGames
    if(userHasFreeGameFromDiceRoll(abTestGroups, freePlayUntil)) return CKRankedState.HasFreeGameFromDiceRoll
    if(userCanRollDiceForCitiesAndKnights(abTestGroups, nextRerollAt, freePlayUntil)) return CKRankedState.CanRollDice
    if(userIsWaitingToRollDiceForCitiesAndKnights(abTestGroups, nextRerollAt)) return CKRankedState.WaitingToRollDice
    return CKRankedState.Locked
}

function userHasNormalAccessToCitiesAndKnights(userItems: UserItems | undefined): boolean {
    if(userItems == undefined) return false
    const citiesAndKnightsData = GameModeDataController.getModeDataForMode(ModeSettingEnum.CitiesAndKnights4P)
    if(citiesAndKnightsData == undefined) throw new ErrorsRanked.ServerErrorCitiesAndKnights()

    if(userItems.membership != undefined) return true
    if(userItems.hasAccessToPremiumMode(citiesAndKnightsData)) return true
    return false
}

function userHasFreeCitiesAndKnightsGame(abTestGroups: Partial<Record<ABTestCategory, string>>, ckTotalGameCount: number | undefined): boolean {
    if(abTestGroups['CK_MONETIZATION_DICE_ROLL'] == 'ONLY_DICE_ROLL') return false
    if(ckTotalGameCount == undefined) return false
    if(ckTotalGameCount < CK_FREE_GAME_COUNT) return true
    return false
}

function userHasFreeGameFromDiceRoll(abTestGroups: Partial<Record<ABTestCategory, string>>, freePlayUntil: Date | undefined): boolean {
    if(abTestGroups['CK_MONETIZATION_DICE_ROLL'] == 'DEFAULT') return false
    if(freePlayUntil == undefined) return false
    if(freePlayUntil.getTime() > Date.now()) return true
    return false
}

function userCanRollDiceForCitiesAndKnights(abTestGroups: Partial<Record<ABTestCategory, string>>, nextRerollAt: Date | undefined, freePlayUntil: Date | undefined): boolean {
    if(abTestGroups['CK_MONETIZATION_DICE_ROLL'] == 'DEFAULT') return false
    if(userHasFreeGameFromDiceRoll(abTestGroups, freePlayUntil)) return false
    if(nextRerollAt == undefined) return true
    if(nextRerollAt.getTime() <= Date.now()) return true
    return false
}

function userIsWaitingToRollDiceForCitiesAndKnights(abTestGroups: Partial<Record<ABTestCategory, string>>, nextRerollAt: Date | undefined): boolean {
    if(abTestGroups['CK_MONETIZATION_DICE_ROLL'] == 'DEFAULT') return false
    if(nextRerollAt == undefined) return false
    if(nextRerollAt.getTime() > Date.now()) return true
    return false
}
